import { render } from "./chat.vue?vue&type=template&id=33f4bb80&scoped=true"
import script from "./chat.vue?vue&type=script&lang=js"
export * from "./chat.vue?vue&type=script&lang=js"

import "./chat.vue?vue&type=style&index=0&id=33f4bb80&lang=css"
import "./chat.vue?vue&type=style&index=1&id=33f4bb80&scoped=true&lang=css"

import exportComponent from "D:\\project\\websites\\zxr_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f4bb80"]])

export default __exports__